import { IFormInput } from "./types";

export const defaultValues: IFormInput = {
  entries: [],
};
